import Cookie from 'js-cookie'
import { jwtDecode } from 'jwt-decode'

export class MissingSessionTokenCookie extends Error {
  constructor () {
    super('session_token cookie is missing')
    this.name = 'MissingSessionTokenCookie'
  }
}

class SessionTokenRefreshError extends Error {
  constructor (message) {
    super(message)
    this.name = 'SessionTokenRefreshError'
  }
}

export async function getJwtCookie () {
  let jwt = Cookie.get('session_token')
  if (!jwt) {
    jwt = await refreshJwtCookie()
  }
  return jwt
}

export async function refreshJwtCookie () {
  // Attempt to fetch  a new session token
  const response = await fetch('/', { credentials: 'include' })
  if (!response.ok) {
    throw new SessionTokenRefreshError(`Failed to refresh session_token cookie. Response status: ${response.status}`)
  }
  const jwt = Cookie.get('session_token')
  if (!jwt) {
    throw new MissingSessionTokenCookie()
  }
  return jwt
}

export function getUserIdFromJwtCookie () {
  const jwt = Cookie.get('session_token')
  if (!jwt) return null

  const payload = jwtDecode(jwt)
  if (payload.user_id) return payload.user_id
  if (payload.sub) return parseInt(payload.sub.split('|')[1], 10)

  return null
}

if (window.Carwow && window.Carwow.registerBugsnagVolumeError) {
  window.Carwow.registerBugsnagVolumeError((error) => {
    const component = error.errorClass.includes('MissingSessionTokenCookie')
    const message = error.errorMessage.includes('session_token cookie is missing')

    return component && message
  })
}
